$ = require 'jquery'
{ Analytics } = require '@trello/atlassian-analytics'
{ featureFlagClient } = require '@trello/feature-flag-client'
{ track } = require '@trello/analytics'

PopOver = require 'app/scripts/views/lib/pop-over'
BoardHeaderOrgMenuView = require 'app/scripts/views/board/board-header-org-menu-view'
Util = require 'app/scripts/lib/util'

module.exports.renderOrgChanges = ->
  if @model.get('closed')
    @renderClosed()
  else
    @renderBoardHeader()

module.exports.refreshOrganization = ->
  oldOrganization = @modelCache.get('Organization', @model.previous('idOrganization'))
  organization = @model.getOrganization()

  if oldOrganization?
    @stopListening oldOrganization

  if organization?
    for prop in ['name', 'logoHash', 'displayName', 'limits']
      @listenTo organization, "change:#{prop}",
        @frameDebounce @renderOrgChanges

  @renderOrgChanges()

module.exports.openOrgMenu = (e) ->
  Util.stop(e)

  track("Board Header", "Open Org Menu", $(e.target).closest('.js-open-org-menu').data('boardtype'))

  if featureFlagClient.get('dataeng.gasv3-event-tracking', false)
    Analytics.sendClickedButtonEvent
      buttonName: 'boardOrganizationButton'
      source: 'boardScreen'

  PopOver.toggle
    elem: $(e.target).closest('a')
    view: new BoardHeaderOrgMenuView({ @model, @modelCache })

  return
